import * as React from "react";
import Svg, { SvgProps, Path, Circle } from "react-native-svg";
const Filter = (props: SvgProps) => (
  <Svg width={24} height={24} fill="none" {...props}>
    <Path stroke="#000" strokeLinejoin="round" d="M3 6h3.5M21 6h-9.5" />
    <Circle cx={9} cy={6} r={2.5} stroke="#000" strokeLinejoin="round" />
    <Path stroke="#000" strokeLinejoin="round" d="M21 12h-2M3 12h11" />
    <Circle
      cx={2.5}
      cy={2.5}
      r={2.5}
      stroke="#000"
      strokeLinejoin="round"
      transform="matrix(-1 0 0 1 19 9.5)"
    />
    <Path stroke="#000" strokeLinejoin="round" d="M3 18h5m13 0h-8" />
    <Circle cx={10.5} cy={18} r={2.5} stroke="#000" strokeLinejoin="round" />
  </Svg>
);
export default Filter;
